export default "__VITE_ASSET__D6NZVF8i__"